<template>
<div class="svg-container-outer">
    <div class="svg-container">
        <loading-charts v-if="loadingData" class="loading-charts"/>
        <select required name="Delivery Type" id="Delivery Type" v-model="manifestTableFilterValue">
            <!-- <option value="Priority">Priority</option> -->
            <option value="Delivery">Delivery</option>
            <option value="Pickup">Pickup</option>
            <option value="All">All</option>
        </select>
        <div class="button-container">
            <input class="search-shipments" type="text" v-model="searchTerm" placeholder="Search shipments..." />
        </div>
        <div class="table-container-main">
            <div class="responsive-table">
                <div class="table-header" id="header">
                    <div class="col-1">Stop</div>
                    <div class="col-2">Arrival</div>
                    <div class="col-3">Address</div>
                    <div class="col-4">Shipment</div>
                </div>
                <loading-charts v-if="loadingTable" class="loading-charts"/>
                <div class="table-row-container">
                    <!-- <div class="table-row" :class="{ 'highlight-row': matchedShipmentIds.includes(shipment.stop) }" :ref="matchedShipmentIds.includes(shipment.stop) ? 'matchedRow' : null" v-for="(shipment) in displayedTripShipments" :key="shipment.stop"> -->
                    <div 
                        class="table-row" 
                        :class="{ 
                            'highlight-row': matchedShipmentIds.includes(shipment.stop ?? shipment.id),
                            'missing-stop-row': isMissingStop(shipment)
                        }"
                        :ref="matchedShipmentIds.includes(shipment.stop ?? shipment.id) ? 'matchedRow' : null"
                        v-for="(shipment) in displayedTripShipments" 
                        :key="shipment.stop || shipment.id || shipment.shipments?.[0]?.shipmentID"
                    >
                        <!-- <div class="col-1" v-if="shipment?.serviceStatus != 'Error'"><p class="shipmentid-text" id="shipmentid-text">{{shipment.stop}}</p></div> -->
                        <div class="col-1">
                        <p 
                            class="shipmentid-text" 
                            :class="{ 'missing-stop-badge': isMissingStop(shipment) }"
                        >
                            {{ isMissingStop(shipment) ? 'No Stop ' + shipment.id : shipment.stop }}
                        </p>
                        </div>
                        <!-- <div class="col-1" v-else><p class="shipmentid-text" style="background-color: red; color: #fff;" id="shipmentid-text">{{shipment.stop}}</p></div> -->
                        <div class="col-2 col-data">{{ shipment?.arrival
                                        ? formatLocalTimeArrival(shipment.arrival)
                                        : "" }}</div>
                        <div class="col-3 col-data" v-if="shipment.address">{{shipment.address.address1}}, {{shipment.address.city}}, {{shipment.address.state}}, {{shipment.address.zipCode}}</div>
                        <!-- <div class="col-3 col-data"><p class="service-text">{{shipment.status}}</p></div> -->
                        <div class="col-4 col-data" v-if="shipment.shipments && shipment.shipments.length > 0">
                            <div v-for="(shipmentItem, item) in shipment.shipments" :key="item">
                                <div class="shipment-status-container">
                                    <p style="flex-wrap: nowrap;" class="shipmentid-text" @click="trackShipment(shipmentItem.shipmentID)">{{shipmentItem.shipmentID}}</p>
                                    <p class="activity-description">{{shipmentItem?.lastActivity?.description ?? ""}}</p>
                                    <p style="font-size: 12px;">{{ shipmentItem?.lastActivity?.activityTime
                                        ? formatLocalTime(shipmentItem.lastActivity.activityTime)
                                        : "" }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="(tripShipments.length == 0)" class="table-row-container">
                    <div class="table-row">
                        <div class="col-1"><p class="shipmentid-text" id="shipmentid-text"></p></div>
                        <div class="col-2 col-data">No Shipments</div>
                        <div class="col-3 col-data"><p class="service-text"></p></div>
                        <div class="col-4"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="button-container">
            <div class="print-selected close-label">
                <p class="print-selected-text download-csv" @click="downloadCSVTest()">Download CSV</p>
                <!-- <p class="print-selected-text download-csv" @click="createStopsPdf()">Download PDF</p> -->
            </div>
        </div>
    </div>
</div>

<shipment-info v-if="toggleTrackShipment" @closeShipmentInfo="closeShipmentInfo($event)" :trackShipmentID="trackShipmentID" :cognitoUser="cognitoUser" :userData="userData"/>
<alert-user  v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {API} from 'aws-amplify';
import ShipmentInfo from './../ShipmentInfo.vue'
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue'
import AlertUser from '../../Popups/AlertUser.vue';
import jsonexport from 'jsonexport'
// import { PDFDocument, StandardFonts } from 'pdf-lib'
import bwipjs from 'bwip-js';

export default {
    components:{
        ShipmentInfo,
        LoadingCharts,
        AlertUser
    },
    props: ['userData', 'cognitoUser', 'filterByRouteCode'],
    data(){
        return{
            trackShipmentID: null,
            toggleTrackShipment: false,
            user: null,
            loadingData: false,
            loadingTable: false,
            isFiltered: false,
            filterField: '',
            filterValue: '',
            toggleAlertBox: '',
            alertMessage: '',
            tripShipments: [],
            searchTerm: '',
            manifestTableFilterValue: "All",
            manifestTableTemporaryData: []
        }
    },
    watch: {
        matchedShipmentIds(newVal) {
            if (newVal.length >= 1) {
                this.$nextTick(() => {
                    const matchedEls = this.$refs.matchedRow || [];
                    const lastMatchedEl = matchedEls[matchedEls.length - 1];

                    if (lastMatchedEl?.scrollIntoView) {
                        lastMatchedEl.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                });
            }
        },
        searchTerm(newTerm) {
            if (newTerm.length < 3) {
                // Clear highlights if search term is less than 3 characters
                this.$refs.matchedRow = [];
            }
        }
    },
    computed: {
        matchedShipmentIds() {
            const search = (this.searchTerm || "").trim().toLowerCase();
            console.log("SEARCH TERM", search);

            if (search.length < 3) return [];

            const containsValue = (val) => {
                if (val == null) return false;

                // handle arrays
                if (Array.isArray(val)) {
                return val.some(containsValue);
                }

                // handle objects
                if (typeof val === "object") {
                return Object.values(val).some(containsValue);
                }

                // primitives
                return String(val).toLowerCase().includes(search);
            };

            const matchedStops = this.tripShipments
                .filter(shipment => containsValue(shipment))
                .map(shipment => shipment.stop ?? shipment.id)
                //.filter(stop => stop != null); // remove null/undefined stops

            // unique + sorted (optional but recommended)
            return [...new Set(matchedStops)].sort((a, b) => a - b);
        },
        displayedTripShipments() {
            const items = this.tripShipments || [];

            if (this.manifestTableFilterValue === "Delivery") {
                return items.filter(item => item?.isDelivery === true);
            }

            if (this.manifestTableFilterValue === "Pickup") {
                return items.filter(item => item?.isDelivery === false || item?.isDelivery == null);
            }

            return items; // "All"
        }
    },
    mounted(){
        this.listManifestWaypointsFunc(this.filterByRouteCode)
        // if (this.filterByTripSheetID) {
        //     let event = {
        //         filterField: "tripSheetID",
        //         filterValue: this.filterByTripSheetID
        //     };

        //     this.runFilter(event);
        // }
    },
    methods:{
        isMissingStop(shipment) {
            if (shipment?.waypoint === "*") {
                return false;
            }
            return shipment?.stop === null || 
                shipment?.stop === undefined || 
                shipment?.stop === "";
        },
        async makePdf417PngBytes(text) {
            const canvas = document.createElement('canvas');
            await bwipjs.toCanvas(canvas, {
                bcid: 'pdf417',
                text: String(text),
                scale: 2,
                height: 10,
                includetext: false,
                columns: 6,
            });

            const blob = await new Promise(res => canvas.toBlob(res, 'image/png'));
            const ab = await blob.arrayBuffer();
            return new Uint8Array(ab);
        },
        async runFilter(event) {
            await this.filterValues(event);
        },
        async filterValues(event){
            console.log("FILTER")
            this.isFiltered = true;
            this.filterField = event.filterField;
            this.filterValue = event.filterValue;

            switch (event.filterField) {
                case "routeCode":
                    this.listManifestWaypointsFunc(this.filterValue);
                    this.isFiltered = false;
                    break;
                default:
                    break;
            }
        },
        async listManifestWaypointsFunc(routeCode) {
            this.loadingData = true;
            this.tripShipments = [];
            let graphqlQuery = `query listManifestWaypoints($nextToken: String, $routeCode: String) {
                listManifestWaypoints(nextToken: $nextToken, routeCode: $routeCode) {
                    items {
                        address {
                            address1
                            address2
                            attention
                            city
                            companyName
                            email
                            latitude
                            longitude
                            phone
                            phoneExt
                            relevance
                            routeCode
                            state
                            zipCode
                        }
                        arrival
                        assignmentRule
                        created
                        deliveries
                        departure
                        distanceCost
                        endTime
                        error
                        fromPreviousDistance
                        fromPreviousTravelTime
                        geometry
                        id
                        isDelivery
                        isDropBox
                        jobID
                        latitude
                        locations {
                            address1
                            address2
                            attention
                            city
                            companyName
                            email
                            latitude
                            locationID
                            longitude
                            phone
                            phoneExt
                            relevance
                            routeCode
                            state
                            zipCode
                        }
                        longitude
                        orderCount
                        overTimeCost
                        pickups
                        radius
                        processed
                        regularTimeCost
                        route
                        routeCode
                        routeEnd
                        routeStart
                        sequence
                        serviceTime
                        shipments {
                            address {
                            address1
                            address2
                            attention
                            city
                            companyName
                            latitude
                            longitude
                            phone
                            relevance
                            routeCode
                            state
                            zipCode
                            }
                            assignedActivities
                            assignedShippingEvent
                            isDelivery
                            isPriority
                            signatureRequired
                            shipmentID
                        }
                        startTime
                        status
                        stop
                        stopType
                        totalBreakServiceTime
                        totalCost
                        totalDistance
                        totalOrderServiceTime
                        totalTime
                        totalTravelTime
                        violatedConstraints
                        waypoint
                        windowStart
                        windowEnd
                        }
                    nextToken
                }
            }`;

            try {
                let allTripShipments = [];
                let nextToken = null;

                do {
                    let response = await API.graphql({
                        query: graphqlQuery,
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                        variables: { nextToken, routeCode }
                    });

                    const data = response.data.listManifestWaypoints;
                    allTripShipments = [...allTripShipments, ...data.items];
                    nextToken = data.nextToken;

                } while (nextToken); 

                this.tripShipments = allTripShipments;
                // allTripShipments = allTripShipments.filter(item => item.stop !== null && item.stop !== undefined);
                allTripShipments.sort((a, b) => a.stop - b.stop);
                this.tripShipments = allTripShipments;
                this.loadingData = false;
            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting trip shipments.";
                this.loadingData = false;
            }
            console.log("ALL TRIP SHIPMENTS", this.tripShipments);
        },
        formatLocalTime(utcDate) {
            const date = new Date(utcDate);

            const formattedDate = date.toLocaleString('en-US', {
                month: 'numeric',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: true
            });

            return formattedDate;
        },
        formatLocalTimeArrival(time24) {
            const [hours, minutes] = time24.split(":");
            const date = new Date();
            date.setHours(hours, minutes, 0, 0);

            // Format to a readable local 12-hour time
            const localTime = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

            return localTime;
        },
        trackShipment(shipmentID){
            this.toggleTrackShipment = true;
            this.trackShipmentID = shipmentID;
        },
        closeShipmentInfo(event){
            this.toggleTrackShipment = event;
            this.$emit("closeShipmentInfoRefresh", true)
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        async downloadCSVTest() {
            console.log("HELLO");
            this.loadingTable = true;

            try {
                let csvArray = [];

                for (const waypoint of (this.displayedTripShipments || [])) {
                    const shipments = Array.isArray(waypoint?.shipments) ? waypoint.shipments : [];

                    // If there are shipments, create one row per shipment
                    if (shipments.length) {
                        for (const shipment of shipments) {
                            csvArray.push({
                                stop: waypoint?.stop ?? "",
                                arrival: waypoint?.arrival ?? "",
                                shipmentID: shipment?.shipmentID ?? "",
                                route: waypoint?.route ?? "",
                                DeliveryCompanyName: shipment?.address?.companyName ?? waypoint?.address?.companyName ?? waypoint?.locations?.companyName ?? "",
                                DeliveryAddress1: shipment?.address?.address1 ?? waypoint?.address?.address1 ?? waypoint?.locations?.address1 ?? "",
                                DeliveryAddress2: shipment?.address?.address2 ?? waypoint?.address?.address2 ?? waypoint?.locations?.address2 ?? "",
                                DeliveryCity: shipment?.address?.city ?? waypoint?.address?.city ?? waypoint?.locations?.city ?? "",
                                DeliveryState: shipment?.address?.state ?? waypoint?.address?.state ?? waypoint?.locations?.state ?? "",
                                DeliveryZipCode: shipment?.address?.zipCode ?? waypoint?.address?.zipCode ?? waypoint?.locations?.zipCode ?? "",
                                TripSheetID: waypoint?.tripSheetID ?? "",
                                Status: waypoint?.serviceStatus ?? ""
                            });
                        }
                    } else {
                        // If no shipments exist, still create a row from waypoint data
                        csvArray.push({
                            stop: waypoint?.stop ?? "",
                            arrival: waypoint?.arrival ?? "",
                            shipmentID: "",
                            route: waypoint?.route ?? "",
                            DeliveryCompanyName: waypoint?.address?.companyName ?? waypoint?.locations?.companyName ?? "",
                            DeliveryAddress1: waypoint?.address?.address1 ?? waypoint?.locations?.address1 ?? "",
                            DeliveryAddress2: waypoint?.address?.address2 ?? waypoint?.locations?.address2 ?? "",
                            DeliveryCity: waypoint?.address?.city ?? waypoint?.locations?.city ?? "",
                            DeliveryState: waypoint?.address?.state ?? waypoint?.locations?.state ?? "",
                            DeliveryZipCode: waypoint?.address?.zipCode ?? waypoint?.locations?.zipCode ?? "",
                            TripSheetID: waypoint?.tripSheetID ?? "",
                            Status: waypoint?.serviceStatus ?? ""
                        });
                    }
                }

                jsonexport(csvArray, (error, csv) => {
                    if (error) {
                        console.log(error);
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error downloading manifest shipments";
                        this.loadingTable = false;
                        return;
                    }

                    const blob = new Blob([csv], { type: "text/csv" });
                    const anchor = document.createElement("a");
                    anchor.href = window.URL.createObjectURL(blob);
                    anchor.download = "TripSheetData.csv";
                    anchor.click();
                    window.URL.revokeObjectURL(anchor.href);
                    anchor.remove();
                    this.loadingTable = false;
                });

            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = "Error downloading manifest shipments";
                this.loadingTable = false;
            }
        }
        // async downloadCSVTest(){
        //     this.loadingTable = true;
        //     let csvArray;

        //     csvArray = this.displayedTripShipments.map(obj =>{
        //         console.log(obj);
        //         return {
        //             Stop: obj.stop ?? "",
        //             Route: obj.route  ?? "",
        //             DeliveryCompanyName: obj.address?.companyName ?? "",
        //             DeliveryAddress1: obj.address?.address1 ?? "",
        //             DeliveryAddress2: obj.address?.address2 ?? "",
        //             DeliveryCity: obj.address?.city ?? "",
        //             DeliveryState: obj.address?.state ?? "",
        //             DeliveryZipCode: obj.address?.zipCode ?? "",
        //         }
        //     })
        //     jsonexport(csvArray, (error, csv) => {
        //         if (error) {
        //             this.toggleAlertBox = true;
        //             this.alertMessage = "Error downloading manifest shipments"
        //         }
        //         const blob = new Blob([csv], { type: 'text/csv' });
        //         const anchor = document.createElement('a');
        //         anchor.href = window.URL.createObjectURL(blob);
        //         anchor.download = 'ManifestWaypoint.csv';
        //         anchor.click();
        //         window.URL.revokeObjectURL(anchor.href);
        //         anchor.remove();
        //         this.loadingTable = false;
        //     })
        // }
    }
}
</script>

<style scoped>
.table-container-main {
	width: 100%;
	margin-top: 0;
	overflow-x: hidden;
	resize: both;
	height: 350px;
}

.responsive-table {
	width: 100%
}

* {
	scrollbar-width: auto;
	scrollbar-color: #f3f3f3 #fff
}

::-webkit-scrollbar {
	width: 16px
}

::-webkit-scrollbar-track {
	background: #fff
}

::-webkit-scrollbar-thumb {
	background-color: #f3f3f3;
	border-radius: 10px;
	border: 3px solid #fff
}

.table-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #32ccfe;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px;
	color: #fff;
	position: sticky;
	top: 0
}

.table-row-container {
	height: 100%;
	overflow-y: auto;
	border-radius: 5px;
	width: 100%;
	animation: animate-table-row 1s ease
}

@keyframes animate-table-row {
	from {
		margin-left: -50px
	}

	to {
		margin-left: 0
	}
}

.missing-stop-row {
  background-color: #fff3cd;
  border-left: 5px solid #ff9800;
}

.missing-stop-badge {
  background-color: #ff9800;
  color: #fff;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: bold;
}

.table-row {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #f3f3f3;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px
}

.table-header .col-1 {
	margin-right: 5px
}

.col-1 {
	flex-basis: 10%;
	text-align: left;
	white-space: nowrap
}

.col-2 {
	flex-basis: 10%;
	text-align: left;
	margin-left: 5px
}

.col-3 {
	flex-basis: 35%;
	text-align: left;
	margin-left: 5px
}

.col-data {
	text-align: left
}

select{
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0,0,0,.336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
    margin-bottom: 5px;
}

.highlight-row {
  background-color: #b9b9b9 !important;
  transition: background-color 0.5s ease-in-out;
}

/* .col-4 {
	flex-basis: 10%;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center
} */
.shipment-status-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    gap: 8px;
    margin-top: 2px;
    margin-bottom: 2px;
}

.shipment-status-container p{
    margin-top: 0;
    margin-bottom: 0;
}

.activity-description{
    margin: 0;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #d4d4d4;
}

.col-4 {
	flex-basis: 45%;
    /* margin-left: auto; */
	display: flex;
	justify-content: flex-start;
	align-items: center;
    flex-wrap: wrap;
    word-break: break-word;
    overflow-wrap: break-word;
}

.col-4 p{
    margin-left: 2px;
    /* font-size: .6rem; */
}

.service-text {
	background-color: #d4d4d4;
	padding: 2.5px 10px;
	border-radius: 999px;
	width: fit-content;
	margin: 0;
	font-size: 12px
}

.shipmentid-text {
	margin: 0;
	color: #6a6a6a;
	width: fit-content;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s
}

.shipmentid-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.svg-container-outer{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.search-shipments{
    border: 1px solid #e2e2e2;
    padding: 5px;
    border-radius: 25px;
    box-shadow: rgba(0, 0, 0, .05) 0 5px 15px;
    outline: 0;
    margin-bottom: 5px;
}

.svg-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: fit-content;
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    /* flex-basis: 25%; */
    min-width: 65%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

input[type=checkbox] {
	-webkit-appearance: none;
	appearance: none;
	background-color: #fff;
	margin: 0;
	cursor: pointer;
	font: inherit;
	color: #33f18a;
	width: 1.05em;
	height: 1.05em;
	border: .15em solid #33f18a;
	border-radius: .15em;
	display: grid;
	place-content: center;
	transition-duration: .5s
}

input[type=checkbox]:hover {
	background-color: #f3f3f3;
	transition-duration: .5s
}

input[type=checkbox]::before {
	content: "";
	width: .65em;
	height: .65em;
	clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0, 43% 62%);
	transform: scale(0);
	transform-origin: bottom left;
	transition: 120ms transform ease-in-out;
	box-shadow: inset 1em 1em var(--form-control-color);
	background-color: CanvasText
}

input[type=checkbox]:checked::before {
	transform: scale(1)
}

.button-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	margin: 0;
	animation: animate-table-row 1s ease
}

.print-selected-text {
	margin: 0;
	margin-bottom: 5px;
	margin-right: 5px;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s
}

.download-csv {
	margin-top: 5px
}

.void-selected-text {
	margin: 0;
	margin-bottom: 5px;
	padding: 2.5px 10px;
	margin-bottom: 5px;
	border-radius: 999px;
	background-color: #fe804d;
	border: 1px solid #ff5512;
	color: #fff;
	transition-duration: .5s
}

.print-selected-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.void-selected-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.close-label {
	margin-left: auto
}

.label-container {
	width: 100%
}

@media only screen and (max-width:600px) {
	.service-text {
		font-size: 8px
	}

    .svg-container-outer{
        font-size: 10px;
    }
}

@media only screen and (max-width:1135px) {
	.col-1 {
		min-width: 10%
	}
}
</style>